import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UspSection from './components/UspSection';
import AtmosphereSection from './components/AtmosphereSection';
import ProgramSection from './components/ProgramSection';
import StandupSection from './components/StandupSection';
import AiSection from './components/AiSection';
import SpeakersSection from './components/SpeakersSection';
import ForWhomSection from './components/ForWhomSection';
import ReviewsSection from './components/ReviewsSection';
import LocationSection from './components/LocationSection';
import OrganizersSection from './components/OrganizersSection';
import CtaSection from './components/CtaSection';
import GiftsSection from './components/GiftsSection';
import Footer from './components/Footer';
import RegistrationSection from './components/RegistrationSection';

export default function HomePage() {
  const [regOpen, setRegOpen] = useState(false);

  return (
    <div className="min-h-screen font-[Manrope,sans-serif]">
      <Header onRegisterClick={() => setRegOpen(true)} />
      <main>
        <HeroSection onRegisterClick={() => setRegOpen(true)} />
        <UspSection />
        <GiftsSection />
        <AtmosphereSection />
        <ProgramSection />
        <StandupSection />
        <AiSection />
        <SpeakersSection />
        <ForWhomSection />
        <ReviewsSection />
        <LocationSection onRegisterClick={() => setRegOpen(true)} />
        <OrganizersSection />
        <CtaSection onRegisterClick={() => setRegOpen(true)} />
      </main>
      <Footer />
      <RegistrationSection isOpen={regOpen} onClose={() => setRegOpen(false)} />

      {/* Mobile sticky CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-gray-100 px-4 py-3 flex items-center justify-between gap-3">
        <div className="text-xs text-gray-500">
          <span className="font-semibold text-[#0f3d32]">NeuroRussia 2026</span>
          <br />
          16–17 апреля • Санкт-Петербург
        </div>
        <button
          onClick={() => setRegOpen(true)}
          className="bg-[#c8963e] text-white font-bold text-sm px-6 py-3 rounded-full whitespace-nowrap cursor-pointer"
        >
          Регистрация
        </button>
      </div>
    </div>
  );
}
